import React from 'react';
import Create from 'containers/rest/Create';
import Form from '../components/Form';

const ReviewsCreate = props => (
  <Create {...props} resource="reviews">
    <Form />
  </Create>
);

ReviewsCreate.propTypes = {};

export default ReviewsCreate;
